import { c as _c } from "react/compiler-runtime";
import { getDisabledRoles } from "@utils/workspace-role-utils";
import { RoleAutocomplete } from "@components/role/role-autocomplete/role-autocomplete";
import { FaroCoreApiConst } from "@stellar/core-api-client";

/** Renders a dropdown to select company role */
export function CompanyRoleAutoComplete(t0) {
  const $ = _c(12);
  const {
    selectedRole,
    onChange,
    onResetSelection,
    isRequired: t1,
    isDisabled,
    placeholder: t2,
    shouldAllowAllRolesSelection: t3,
    roles: t4
  } = t0;
  const isRequired = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "Select a role..." : t2;
  const shouldAllowAllRolesSelection = t3 === undefined ? false : t3;
  const roles = t4 === undefined ? FaroCoreApiConst.allCompanyRoles : t4;
  let t5;
  if ($[0] !== selectedRole || $[1] !== shouldAllowAllRolesSelection) {
    t5 = shouldAllowAllRolesSelection || !selectedRole ? [] : getDisabledRoles(selectedRole);
    $[0] = selectedRole;
    $[1] = shouldAllowAllRolesSelection;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const disabledRoles = t5;
  const t6 = roles;
  const t7 = disabledRoles;
  let t8;
  if ($[3] !== isDisabled || $[4] !== isRequired || $[5] !== onChange || $[6] !== onResetSelection || $[7] !== placeholder || $[8] !== selectedRole || $[9] !== t6 || $[10] !== t7) {
    t8 = <RoleAutocomplete labelTitle="Workspace role" isRequired={isRequired} isDisabled={isDisabled} selectedRole={selectedRole} onChange={onChange} onResetSelection={onResetSelection} placeholder={placeholder} roles={t6} disabledRoles={t7} link="workspaceRolesHelp" dataTestId="workspace-role-selector" />;
    $[3] = isDisabled;
    $[4] = isRequired;
    $[5] = onChange;
    $[6] = onResetSelection;
    $[7] = placeholder;
    $[8] = selectedRole;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}